import { useCallback, useEffect, useState } from 'react';
import { TOption } from '@src/types';
import { getStates } from '@src/services/dropdown.ts';

export const useStateOptions = () => {
  const [stateOptions, setStateOptions] = useState<TOption[]>([]);

  const fetchStateOptions = useCallback(async () => {
    const res = await getStates();

    const options: TOption[] = res.data.map((item) => ({
      label: item.label,
      value: item.value,
      zipRange: item.zip_ranges,
    }));

    setStateOptions(options);
  }, []);

  useEffect(() => {
    fetchStateOptions().then();
  }, [fetchStateOptions]);

  return { stateOptions, refresh: fetchStateOptions };
};
